<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Entitlements
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
      >
        <b-col
          class="content-header-right mb-2 ml-auto"
          cols="12"
          md="12"
        >
          <b-button
            v-if="canViewThisAction('redeem', 'Entitlement')"
            variant="success"
            class="mobile_create_button"
            @click="openRedemptionCodeModal"
          >
            <feather-icon
              icon="GiftIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle d-md-block d-none">Redeem an Entitlement</span>
            <span class="align-middle d-md-none d-block">Redeem</span>
          </b-button>
        </b-col>
        <b-dropdown
          v-if="isMobile()"
          :text="currentTabTitle"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="(tab, index) in pageTabs"
            :key="index"
            @click="changeRoute(tab.param)"
          >
            {{ tab.title }} ({{ tab.count }})
          </b-dropdown-item>
        </b-dropdown>
        <b-tabs
          pills
          class="booking__content"
          :nav-class="[isMobile() ? 'd-none' : '']"
        >
          <!-- Tab: Account -->
          <b-tab
            :active="$route.params.type == 'redeemable'"
            lazy
            @click="changeRoute('redeemable')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Redeemable <span class="rounded-number">{{ redeemableCount }}</span></span>
            </template>
            <redeemable-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'used'"
            lazy
            @click="changeRoute('used')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Used <span class="rounded-number">{{ usedCount }}</span></span>
            </template>
            <used-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'expired'"
            lazy
            @click="changeRoute('expired')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Expired <span class="rounded-number">{{ expiredCount }}</span></span>
            </template>
            <expired-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'cancelled'"
            lazy
            @click="changeRoute('cancelled')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Cancelled <span class="rounded-number">{{ cancelledCount }}</span></span>
            </template>
            <cancelled-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'all-entitlement'"
            lazy
            @click="changeRoute('all-entitlement')"
          >
            <template #title>
              <span class="d-none d-sm-inline">All Entitlement <span class="rounded-number">{{ allCount }}</span></span>
            </template>
            <all-entitlement
              class="mt-2 pt-75"
              @emitCountEntitlement="countEntitlements"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <b-modal
      id="modal-redemption-code-list"
      ref="redemption-code-modal"
      centered
      hide-footer
      modal-class="redemption-code-modal"
      no-close-on-backdrop
      @hide="redemptionCode = ['','','','','','','','']; redemptionCodeError = ''"
    >
      <template #modal-header>
        <button
          type="button"
          class="close"
          @click="$bvModal.hide('modal-redemption-code-list')"
        >
          ×
        </button>
      </template>
      <div class="text-center redemption-wrapper">
        <div class="gift-icon-wrapper">
          <feather-icon
            icon="GiftIcon"
            size="80"
            class="gift-icon"
          />
        </div>
        <h3 class="redemption-title">
          Enter Redemption Code
        </h3>
        <p class="redemption-description">
          This code can be generated only by customer using their Nirvana SG customer app for verification purposes.
        </p>
        <div class="redemption-code-group">
          <div
            v-for="(_, index) in redemptionCode"
            :key="index"
            class="code-wrapper"
          >
            <b-form-input
              v-model="redemptionCode[index]"
              maxlength="1"
              class="code-input"
              @paste="handlePaste"
              @input="handleInput(index, $event)"
            />
            <span
              v-if="index === 3"
              class="divider"
            >
              —
            </span>
          </div>
        </div>
        <div
          v-if="redemptionCodeError"
          class="text-danger text-center mb-1"
          style="font-size: 13px;"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="14"
            class="mr-25"
          />
          {{ redemptionCodeError }}
        </div>
        <div class="bottom-line" />
        <div class="d-flex justify-content-center mt-2">
          <b-button
            variant="outline-primary"
            class="mr-1 px-2"
            @click="$bvModal.hide('modal-redemption-code-list')"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="px-2"
            @click="redeemEntitlement"
          >
            Redeem this Entitlement
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BTab, BTabs, BDropdown, BDropdownItem, BButton, BModal, BFormInput,
} from 'bootstrap-vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AllEntitlement from './all-entitlements/AllEntitlement.vue'
import RedeemableEntitlement from './redeemable-entitlements/RedeemableEntitlement.vue'
import UsedEntitlement from './used-entitlements/UsedEntitlement.vue'
import ExpiredEntitlement from './expired-entitlements/ExpiredEntitlement.vue'
import CancelledEntitlement from './cancelled-entitlements/CancelledEntitlement.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BRow,
    BCol,
    BTab,
    BTabs,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    BFormInput,

    AllEntitlement,
    RedeemableEntitlement,
    UsedEntitlement,
    ExpiredEntitlement,
    CancelledEntitlement,
  },
  data() {
    return {
      allCount: 0,
      redeemableCount: 0,
      redemptionCode: ['', '', '', '', '', '', '', ''],
      redemptionCodeError: '',
      usedCount: 0,
      expiredCount: 0,
      cancelledCount: 0,
      currentTabTitle: '',
      pageTabs: [
        {
          title: 'Redeemable',
          param: 'redeemable',
          count: 0,
        },
        {
          title: 'Used',
          param: 'used',
          count: 0,
        },
        {
          title: 'Expired',
          param: 'expired',
          count: 0,
        },
        {
          title: 'Cancelled',
          param: 'cancelled',
          count: 0,
        },
        {
          title: 'All Entitlements',
          param: 'all-entitlement',
          count: 0,
        },
      ],
    }
  },
  watch: {
    $route() {
      const param = this.$route.params.type
      const currentTab = this.pageTabs.find(o => o.param === param)
      if (currentTab) {
        this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
      }
    },
  },
  beforeMount() {
    this.countEntitlements()
  },

  methods: {
    canViewThisAction,
    openRedemptionCodeModal() {
      this.redemptionCode = ['', '', '', '', '', '', '', '']
      this.redemptionCodeError = ''
      this.$bvModal.show('modal-redemption-code-list')
    },
    handlePaste(event) {
      event.preventDefault()
      const pastedData = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 8)
      if (!pastedData) return
      pastedData.split('').forEach((char, index) => {
        this.$set(this.redemptionCode, index, char)
      })
    },
    handleInput(index, value) {
      const cleaned = (value || '').replace(/\D/g, '').slice(0, 1)
      this.$set(this.redemptionCode, index, cleaned)
      if (this.redemptionCodeError) this.redemptionCodeError = ''
      if (cleaned && index < 7) {
        this.$nextTick(() => {
          const inputs = document.querySelectorAll('.code-input')
          if (inputs[index + 1]) inputs[index + 1].focus()
        })
      }
    },
    redeemEntitlement() {
      const code = this.redemptionCode.join('')
      if (code.length < 8) {
        this.redemptionCodeError = 'Please enter the complete 8-digit redemption code.'
        return
      }
      this.redemptionCodeError = ''
      const formData = new FormData()
      formData.append('code', code)
      this.$http.post('customer/entitlements/lookup-by-code', formData)
        .then(response => {
          this.$bvModal.hide('modal-redemption-code-list')
          this.$router.push({
            name: 'customers-entitlements-show',
            params: { id: response.data.entitlement._id },
            query: {
              redeemCode: code,
              processingExpiresAt: response.data.processingExpiresAt,
            },
          })
        })
        .catch(error => {
          this.redemptionCodeError = error.data?.message ?? 'Invalid redemption code. Please try again.'
        })
    },
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    countEntitlements() {
      this.$http.get('customer/entitlements/counts')
        .then(response => {
          this.allCount = response.data.allCount
          this.redeemableCount = response.data.redeemableCount
          this.usedCount = response.data.usedCount
          this.expiredCount = response.data.expiredCount
          this.cancelledCount = response.data.cancelledCount

          this.pageTabs.forEach(element => {
            if (element.title === 'All Entitlements') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.allCount
            } else if (element.title === 'Redeemable') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.redeemableCount
            } else if (element.title === 'Used') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.usedCount
            } else if (element.title === 'Expired') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.expiredCount
            } else if (element.title === 'Cancelled') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.cancelledCount
            }
          })

          const param = this.$route.params.type

          const currentTab = this.pageTabs.find(o => o.param === param)
          if (currentTab) {
            this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.redemption-code-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}
.code-input {
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 20px;
  border-radius: 6px;
  border: 1px solid #d8d8d8;
  &:focus {
    border-color: #0052cc;
    box-shadow: none;
  }
}
.code-wrapper {
  display: flex;
  align-items: center;
}
.gift-icon {
  color: #ea5455;
}
.redemption-wrapper {
  position: relative;
}
.modal-close-btn,
.close {
  position: relative;
  z-index: 9999;
}
.rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
  }
</style>
